import './App.css';

function App() {
  return (
    <div className="App" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
      <iframe
        src="/PP.pdf"
        title="PP.pdf"
        width="100%"
        height="100%"
        style={{ border: 'none', position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh' }}
      />
    </div>
  );
}

export default App;
